const Chevron = ({ height = "12", width = "12", rotate = "" }) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    width={width}
    height={height}
    style={rotate ? { transform: `rotate(${rotate}deg)` } : {}}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4992_24760)">
      <path
        d="M6.47417 9.51414C6.21304 9.77528 5.79078 9.77528 5.53242 9.51414L0.19585 4.18035C-0.0652833 3.91921 -0.0652834 3.49695 0.19585 3.2386C0.456984 2.98024 0.879242 2.97746 1.1376 3.2386L5.99913 8.10013L10.8634 3.23582C11.1246 2.97469 11.5468 2.97469 11.8052 3.23582C12.0635 3.49695 12.0663 3.91921 11.8052 4.17757L6.47417 9.51414Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_4992_24760">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Chevron;
